import { type CSSProperties, PureComponent, type ReactNode } from 'react';

import classNames from 'classnames';

import { nameInitials } from '@iconik-io/core/src/name_initials';

import type { IconType } from '../../icons/constants';
import Icon from '../../icons/icon';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';
import type { TooltipPlacement } from '../tooltip_trigger/utils';

import styles from './user_bubble.module.css';

type Props = {
  size: 'sm' | 'xl' | 'xs' | 'xxs' | 'md';
  name: string;
  icon?: IconType;
  src?: string;
  onClick?: () => void;
  style?: CSSProperties;
  showTooltip: boolean;
  className?: string;
  initialsClassName?: string;
  placement: TooltipPlacement;
  variant?: 'round' | 'square';
};

type State = {
  loaded?: boolean;
};

class UserBubble extends PureComponent<Props, State> {
  static defaultProps = {
    size: 'sm',
    showTooltip: true,
    placement: 'top',
  };

  state: State = {};

  onLoad = (): void => {
    this.setState({ loaded: true });
  };

  render(): ReactNode {
    const name = this.props.name || ' ';
    const lastName = name.split(' ').length > 1 ? name.split(' ').pop() : ' ';
    const imageLoaded = this.state.loaded && this.props.src;
    return (
      <TooltipTrigger
        tooltipText={this.props.showTooltip ? this.props.name : undefined}
        componentProps={{
          style: this.props.style,
          className: classNames(
            styles.component,
            styles[this.props.size],
            this.props.className,
            styles[this.props.variant ?? 'round'],
          ),
          onClick: this.props.onClick,
        }}
        placement={this.props.placement}
      >
        <div />
        {!imageLoaded && !this.props.icon ? (
          <span
            className={classNames(
              styles.initials,
              this.props.initialsClassName,
            )}
          >
            {nameInitials({ first_name: name, last_name: lastName })}
          </span>
        ) : undefined}
        {!imageLoaded && this.props.icon ? (
          <Icon
            icon={this.props.icon}
            className={styles.icon}
            size={this.props.size === 'xl' ? 90 : undefined}
          />
        ) : undefined}
        {this.props.src && (
          <img
            src={this.props.src}
            key={this.props.src}
            alt=""
            onLoad={this.onLoad}
          />
        )}
      </TooltipTrigger>
    );
  }
}

export default UserBubble;
